import { jsx as r } from "react/jsx-runtime";
const C = () => /* @__PURE__ */ r(
  "path",
  {
    d: "M13.4893 1.31978C12.7423 1.10225 11.9413 1.40404 11.5236 2.06046L4.52359 13.0605C4.18068 13.5993 4.15858 14.2822 4.46594 14.8421C4.7733 15.402 5.36128 15.75 6 15.75H9.25L9.25 21C9.25 21.778 9.7637 22.4627 10.5107 22.6802C11.2578 22.8977 12.0587 22.5959 12.4764 21.9395L19.4764 10.9395C19.8193 10.4007 19.8414 9.71778 19.5341 9.15788C19.2267 8.59798 18.6387 8.25 18 8.25L14.75 8.25V2.99999C14.75 2.22193 14.2363 1.53732 13.4893 1.31978Z",
    fill: "currentColor"
  }
);
export {
  C as default
};
